module.exports = __webpack_public_path__ + "img/huankuan_touxiang.8144ece5.png";